<div class="flex items-center">
    <div class="flex items-center justify-between w-full">
        <button
            class="flex flex-row items-center"
            mat-button
            #applyViewFilterTrigger="matMenuTrigger"
            [matTooltip]="'Menu'"
            matTooltipPosition="above"
            [matMenuTriggerFor]="notificationsMenu">
            <mat-icon class="ml-2" iconPositionEnd>more_horiz</mat-icon>
        </button>
            <mat-menu #notificationsMenu>
                <button mat-menu-item
                        (click)="triggerMarkAllRead()">
                    <mat-icon fontSet="material-icons-outlined" class="mr-4">mark_email_unread</mat-icon>
                    <span>Mark all as read</span>
                </button>
                <button mat-menu-item
                        (click)="triggerClearAll()">
                <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
                    <span>Clear all</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item
                    (click)="router.navigate(['/settings/notifications'])"
                    aria-label="Go to notification settings"
                    class="text-cool-gray-300 flex items-center"
                >
                    <mat-icon fontSet="material-symbols-outlined" class="h-5 w-5">settings</mat-icon>
                    <span>Go to settings</span>
                </button>
            </mat-menu>
    </div>
</div>